import { render } from "./FormPracticalHelpView.vue?vue&type=template&id=2d507de8"
import script from "./FormPracticalHelpView.vue?vue&type=script&lang=js"
export * from "./FormPracticalHelpView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__